/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { MAIN_PAGE_TITLE } from '~/constants/page-constants'
import type { BreadcrumbLink } from '~/types/product.model'

const getBreadcrumbItemList = ({
  links,
  origin,
  startingPositionIndex,
}: {
  links: BreadcrumbLink[]
  origin: string
  startingPositionIndex: number
}) =>
  links.map((linkItem, i) => {
    const linkUrl = 'url' in linkItem ? linkItem.url : undefined
    const hasOrigin = linkUrl?.startsWith('http')
    return {
      '@type': 'ListItem',
      'position': i + startingPositionIndex,
      'name': linkItem.name,
      ...(linkUrl && {
        item: `${hasOrigin ? '' : origin}${linkUrl}`,
      }),
    }
  })

export const useBreadcrumbPageSchema = (links: BreadcrumbLink[]): void => {
  const requestUrl = useRequestURL()
  const { origin } = requestUrl

  const predefinedItems = [
    {
      '@type': 'ListItem',
      'position': 1,
      'name': MAIN_PAGE_TITLE,
      'item': origin,
    },
  ]

  const itemListElements = computed(() =>
    getBreadcrumbItemList({
      links,
      origin,
      startingPositionIndex: predefinedItems.length + 1,
    }),
  )

  useHead(() => ({
    script: [
      {
        type: 'application/ld+json',
        innerHTML: {
          '@context': 'https://schema.org',
          '@type': 'BreadcrumbList',
          'itemListElement': [...predefinedItems, ...itemListElements.value],
        },
      },
    ],
  }))
}
